<template>
  <button
    type="button"
    @click="clickedBtn" 
    :title="!show ? label : null"
    :aria-label="label"
    :aria-expanded="isDropdown ? String(open) : undefined"
    :class="{ 
      'bg-white':true,
      'navbar-menu-item ': show, 
      'navbar-menu-item-small': !show,
      active: active,
      pointer: true,
      hover: !active
    }" 
  >
    <span class="navbar-menu-link">
      <font-awesome-icon class="menu-icon" :icon="['fa-solid',paramBtn.iconName]" />
      <span class="menu-text" v-if="show">
        <slot></slot>
      </span>
      <span
        v-if="badge"
        class="menu-badge"
        :class="{ 'menu-badge--compact': !show }"
      >{{ badge }}</span>

      <span v-if="isDropdown" v-show="show" class="right-component">
        <font-awesome-icon class="chevron" :class="{ 'chevron-open': open }" icon="fa-solid fa-chevron-down" />
      </span>

    </span>
  </button>
</template>

<script>
import { computed } from 'vue'


export default {
  name: 'my-menu-button',
  props:{
    paramBtn: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    badge: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],

  setup(props,ctx){
    const label = computed(() => props.paramBtn.name || '')
    const isDropdown = computed(() => props.paramBtn.typeBtn === 'droper')

    function clickedBtn(){
      ctx.emit('click')
    }


    return{clickedBtn,label,isDropdown}
  },
};
</script>

<style scoped>

.navbar-menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 46px;
  font-size: 16px;
  border-radius: 7px;
  border: none;
  margin-top: 8px;
  padding: 0 16px;
}


.navbar-menu-item-small {
  display: flex;
  align-items: center;
  position: relative;
  width: 60px;
  height: 46px;
  font-size: 16px;
  border-radius: 7px;
  border: none;
  margin-top: 8px;
  padding: 0;
}

.bg-white{
  background-color: rgb(255 255 255);
}

.navbar-menu-link {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  gap: 12px;
}

.navbar-menu-item-small .navbar-menu-link {
  justify-content: center;
}

.menu-icon {
  flex-shrink: 0;
}

.menu-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu-badge {
  margin-left: auto;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9999px;
  background: #dc2626;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  flex-shrink: 0;
}

.navbar-menu-item.active .menu-badge {
  background: #fff;
  color: #4f46e5;
}

.menu-badge--compact {
  position: absolute;
  top: 4px;
  right: 8px;
  margin-left: 0;
}

.hover:hover:not(.active){
  background-color: rgba(207,207,208,1) !important;
}

.pointer{
  cursor: pointer;
}

.active{
  background-color: rgba(79,70,229, 1) !important;
  color: white ;
}

.right-component{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}

.chevron {
  transition: transform 0.2s ease;
}

.chevron-open {
  transform: rotate(180deg);
}
</style>
